import React from 'react';

const CheckboxInput: React.FC<{
  id: string;
  label: string;
  register: any;
}> = ({ id, label, register }) => {
  return (
    <div className="flex flex-row">
      <input
        className="h-4 w-4 border border-neutral-300 rounded-sm bg-white checked:bg-primary-600 checked:border-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 transition-colors duration-200 mt-1 align-top float-left mr-2 cursor-pointer"
        type="checkbox"
        {...register(id)}
        id={id}
      />
      <label
        className="inline-block font-main text-neutral-900 text-body cursor-pointer"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
};

export default CheckboxInput;
